<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/page1-bg.png">
    <img class="header-phone" src="@/assets/page1-bg-phone.png">
    <img class="logo" src="@/assets/logo.png" alt="logo">
    <!-- <div class="title-bg"></div> -->
    <div class="title-text">My Hero Academia</div>
    <div class="title-text2">Final Heroes</div>
    <div class="content">
      <div class="content-wrapper">
        <p>The climactic battle RPG of the My Hero Academia universe! As UA High faces its greatest crisis, YOU must assemble the final hero team to stop the ultimate villain uprising. </p>
        <p>1.Final Quirk Awakening</p>
        <p>Unlock never-before-seen power evolutions for Deku and villains</p>
        <p>2.Reach the Pinnacle of Glory</p>
        <p>Battle against elite opponents and seize the championship throne!</p>
        <p>3.Console-Quality 3D</p>
        <p>mmerse yourself in epic, visually stunning 3D environments</p>
        <p>4.Diverse & Exciting Game Modes</p>
        <p>Experience endless fun with multiple unique gameplay styles</p>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .header-img{
    width: 100%;
    // height: 1080px;
  }
  .logo{
    position: absolute;
    top: 20px;
    left: 100px;
    width: 160px;
    height: 160px;
  }
  .header-phone{
    display: none;
  }
  .title-bg{
    position: absolute;
    top: 180px;
    left: calc(50% - 340px);
    width: 680px;
    height: 254px;
    background: url(../assets/title-bg.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    font-size: 120px;
    font-family: titleFont;
    padding-top: 20px;
    text-shadow: 4px 4px 8px rgba(255, 255, 255, 1);
  }
  .title-text{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 220px;
    left: calc(50% - 520px);
    color: #fff;
    text-shadow: 4px 4px 10px rgb(23, 123, 236);
  }
  .title-text2{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 320px;
    left: calc(50% - 340px);
    color: #fff;
    text-shadow: 4px 4px 10px rgb(23, 123, 236);
  }
  .content{
    position: absolute;
    padding: 36px;
    top: 560px;
    left: calc(50% - 600px);
    width: 1200px;
    height: 680px;
    background: url(../assets/content-bg.png);
    background-size: 100% 100%;
    font-size: 30px;
    .content-wrapper{
      max-height: 660px;
      overflow: auto;
      p{
        margin-bottom: 20px;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .header-content{
    .title-bg{
      top: 120px;
    }
    .content{
      top: 400px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 870px;
    }
    .logo{
      top: 20px;
      left: 20px;
      width: 120px;
      height: 120px;
    }
    .title-bg{
      top: 10px;
      left: calc(50% - 170px);
      width: 340px;
      height: 127px;
      font-size: 70px;
      padding-top: 0;
    }
    .title-text{
      font-size: 30px;
      font-family: titleFont;
      position: absolute;
      top: 100px;
      left: calc(50% - 120px);
    }
    .title-text2{
      font-size: 30px;
      font-family: titleFont;
      position: absolute;
      top: 134px;
      left: calc(50% - 70px);
    }
    .content{
      top: 320px;
      padding: 36px;
      left: calc(50% - 278px);
      width: 556px;
      height: 430px;
      max-height: 430px;
      overflow: auto;
      background: url(../assets/content-phone-bg.png);
      background-size: 100% 100%;
      .content-wrapper{
        max-height: 420px;
        overflow: auto;
      }
    }
  }
}
</style>